import React from "react";

import { Checkbox } from "rsuite";
import styled from "styled-components";

import { Icon } from "components/Icon";
import css from "./CheckboxBadge.module.css";


const CheckboxBadge = ({ children, wrapperClassName, noPlus, ...props }) => {

    return (
        <div className={[css.CheckboxBadgeWrapper, wrapperClassName].join(" ")}>
            <StyledCheckbox {...props}>
                <div className={css.CheckboxBadge}>

                    {!noPlus
                        ? <Icon icon={"plus"} className={"mr-1"} />
                        : <Icon icon={"check"} className={"mr-1"} />
                    }
                    {children}
                </div>
            </StyledCheckbox>
        </div>
    );
};

CheckboxBadge.displayName = "Checkbox";

export default CheckboxBadge;

const StyledCheckbox = styled(Checkbox)`
    && .rs-checkbox-label {
        white-space: nowrap;
    }

    && .rs-checkbox-label > div {
        display: inline-flex;
        align-items: center;
        white-space: nowrap;
    }

    .rs-checkbox-checker .rs-checkbox-control::before {
        display: none;
        transition: none;
    }

    .rs-checkbox-checker .rs-checkbox-control .rs-checkbox-inner::before {
        border: none;
        transition: none;
    }
`;
